import { Divider, Grid, Typography, styled, useTheme } from '@mui/material';
import React from 'react';
import { IActivitySummary } from '../../redux/client/clientSlice';
import { ActivityTypeEnum, AdvanceActivityStepType } from '../../types/activity';
import { capitalizeFirstLetter } from './Engagement/Activities';
import AdvancedTrackingActivityLineChart from './Engagement/LineChart';
import AdvancedTrackingActivityBarChart from './Engagement/BarChart';
import AdvancedTrackingActivityScatterChart from './Engagement/ScatterChart';

function AdavanceActivityCharts({ activity }: { activity: IActivitySummary }) {
  const theme = useTheme();

  const Item = styled(Grid)(() => ({
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    boxShadow: theme.borderStyles.cardBorders,
    borderRadius: '10px',
    gap: theme.spacing(4),
  }));

  return (
    <Grid container spacing={2}>
      {activity.responseSummary.map((advanceStep) => {
        if (
          activity.schedule !== ActivityTypeEnum.ONETIME &&
          advanceStep.advanceStepType === AdvanceActivityStepType.PERCENTAGE
        ) {
          return (
            <Grid item xs={4} key={advanceStep.text}>
              <Item>
                <Typography variant="bodyBold" color="primary">
                  {capitalizeFirstLetter(advanceStep.text)}
                </Typography>
                <Divider sx={{ mt: '24px', mb: '36px' }} />
                <AdvancedTrackingActivityLineChart objectiveProgress={advanceStep.data} />
              </Item>
            </Grid>
          );
        }
        if (
          activity.schedule !== ActivityTypeEnum.ONETIME &&
          advanceStep.advanceStepType === AdvanceActivityStepType.NUMBER
        ) {
          return (
            <Grid item xs={4} key={advanceStep.text}>
              <Item>
                <Typography variant="bodyBold" color="primary">
                  {capitalizeFirstLetter(advanceStep.text)}
                </Typography>
                <Divider sx={{ mt: '24px', mb: '36px' }} />
                <AdvancedTrackingActivityBarChart objectiveProgress={advanceStep.data} />
              </Item>
            </Grid>
          );
        }
        if (
          activity.schedule !== ActivityTypeEnum.ONETIME &&
          advanceStep.advanceStepType === AdvanceActivityStepType.SELECTION
        ) {
          return (
            <Grid item xs={4} key={advanceStep.text}>
              <Item>
                <Typography variant="bodyBold" color="primary">
                  {capitalizeFirstLetter(advanceStep.text)}
                </Typography>
                <Divider sx={{ mt: '24px', mb: '36px' }} />
                <AdvancedTrackingActivityScatterChart objectiveProgress={advanceStep.data} />
              </Item>
            </Grid>
          );
        }
        return null;
      })}
    </Grid>
  );
}

export default React.memo(AdavanceActivityCharts);
